//#region redux
import { receiptSnoozed } from "store/actions/receiptActions";
import { useDispatch } from "react-redux";
//#endregion
//#region types
import { WintSuperkollAPIModel } from "wint-api-client/dist/types";
import { TranslationKeys } from "translations";
//#endregion
import useSnoozeAction from "components/common/useSnoozeAction";
import { LocalizationHelperInstance } from "utils/helpers";

function useReceiptSnoozeAction(id: number | string, markAsDone: (id: number | string) => void) {
  const dispatch = useDispatch();

  const onSnoozeSuccess = () => {
    dispatch(receiptSnoozed(id as number));
    markAsDone(id);
  };

  const { snoozeAction } = useSnoozeAction(
    id,
    WintSuperkollAPIModel.TodoType.Receipt,
    onSnoozeSuccess,
    LocalizationHelperInstance.getFormattedMessage(TranslationKeys.Receipt.Receipt)
  );

  return snoozeAction;
}

export default useReceiptSnoozeAction;
